// removed by extract-text-webpack-plugin
module.exports = {"sdk":"_1gBPxQhOSAuuyaMcFW-4mm","wrapperCol":"_1ZByI0uEK3crcS25-oi8EV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BundleEdit/index.less
// module id = 405
// module chunks = 0